import { createRouter, createWebHistory } from 'vue-router'
/* --------------------------------------------------
   RUTAS PUBLICAS
-------------------------------------------------- */
const publicRoutes = [
  { path: '/', name: 'login', component: () => import("../views/LoginView.vue")},
  { path: '/registrar', name: 'registrar', component: () => import("../views/Register.vue") },
  { path: '/recuperarpasouno', name: 'recuperarpasouno', component: () => import("../views/pasounoRecuperarPass.vue") },
  { path: '/externalrecuperacionpass', name: 'externalrecuperacionpass', component: () => import("../views/externalchangepass.vue") },
  { path: '/loginadmin', name: 'loginadmin', component: () => import("../views/LoginAdminView.vue") },
]

/* --------------------------------------------------
   RUTAS COMUNES (Necesitan login)
   Sesiones permitidas: clientes + entidadFinanciera
-------------------------------------------------- */
const commonRoutes = [
  {
    path: '/miperfil',
    name: 'miperfil',
    component: () => import("../views/perfilUsuario/perfilusuarioView.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes', 'entidadFinanciera'] },
  },
  {
    path: '/editperfilusern',
    name: 'perfil',
    component: () => import("../views/perfilUsuario/editarperfilusern.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes', 'entidadFinanciera'] },
  },
  {
    path: '/changepass',
    name: 'changepass',
    component: () => import("../views/layout/changepass.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes', 'entidadFinanciera'] },
  },
  {
    path: '/terminosycondiciones',
    name: 'terminosycondiciones',
    component: () => import("../views/layout/terminoscondiciones.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes', 'entidadFinanciera'] },
  },
]

/* --------------------------------------------------
   RUTAS DE USUARIO NORMAL
-------------------------------------------------- */
const userNormalRoutes = [

  // 888888888888888888888888 ROBOT CONTROL
  {
    path: '/raspberry', name: 'raspberry',
    component: () => import("../views/servosystem/raspberrys.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/buscaramigos', name: 'amistades',
    component: () => import("../views/perfilUsuario/buscaramigos.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/solicitudesamistad', name: 'solicitudesamistad',
    component: () => import("../views/perfilUsuario/solicitudesAmistad.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/amigos', name: 'amigos',
    component: () => import("../views/perfilUsuario/amigos.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  
  {
    path: '/creacionbtns', name: 'creacionbtns',
    component: () => import("../views/websocket/creacionbtns.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/btnlauncher', name: 'btnlauncher',
    component: () => import("../views/websocket/btnlauncher.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/servocolecciones', name: 'servocolecciones',
    component: () => import("../views/websocket/servocolecciones.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/solicitudescolecciones', name: 'solicitudesColecciones',
    component: () => import("../views/websocket/solicitudesColecciones.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/secuencias', name: 'secuencias',
    component: () => import("../views/secuencias/secuencias.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/btnservoedit', name: 'btnservoedit',
    component: () => import("../views/websocket/btnservoedit.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  },
  {
    path: '/servohistorial', name: 'servohistorial',
    component: () => import("../views/websocket/servohistorial.vue"),
    meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  }, // 888888888888888888888888 END ROBOT CONTROL
]

/* --------------------------------------------------
   RUTAS ADMIN
-------------------------------------------------- */
const adminRoutes = [
  {
    path: '/administracionusuarios',
    name: 'usuarios',
    component: () => import("../views/administracion/administracionUsuario.vue"),
    meta: { requiresAuth: true, allowedSessions: ['admin'] },
  },
  {
    path: '/administraciondenuncias',
    name: 'administraciondenuncias',
    component: () => import("../views/administracion/administracionDenuncias.vue"),
    meta: { requiresAuth: true, allowedSessions: ['admin'] },
  },
  // {
  //   path: '/terminoscondiciones',
  //   name: 'terminoscondiciones',
  //   component: () => import("../views/administracion/administracionTermcond.vue"),
  //   meta: { requiresAuth: true, allowedSessions: ['admin'] },
  // },
  {
    path: '/terminoscondiciones',
    name: 'terminoscondiciones',
    component: () => import("../views/administracion/administracionTerminoscondiciones.vue"),
    meta: { requiresAuth: true, allowedSessions: ['admin'] },
  },
]

/* --------------------------------------------------
   RUTAS DEL DASHBOARD GENERAL
-------------------------------------------------- */
const dashboard = {
  path: "/dashboard",
  name: "dashboard",
  redirect: "/crudTemplateView",
  component: () => import("../views/layout/mainMenu.vue"),
  // meta: { requiresAuth: true, allowedSessions: ['clientes', 'entidadFinanciera'] },
  meta: { requiresAuth: true, allowedSessions: ['clientes'] },
  children: [
    ...commonRoutes,
    ...userNormalRoutes,
    ...adminRoutes,
  ]
}


/* --------------------------------------------------
   RUTAS FINALES UNIDAS
-------------------------------------------------- */
const routes = [
  ...publicRoutes,
  dashboard,
  // dashboard2
]

/* --------------------------------------------------
   CONFIGURACIÓN DEL ROUTER
-------------------------------------------------- */
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

/* --------------------------------------------------
   GUARD GLOBAL
-------------------------------------------------- */
router.beforeEach((to, from, next) => {
  const terminos_aceptados = localStorage.getItem('terminos_aceptados');
  const token = localStorage.getItem('access_token')
  const typesession = localStorage.getItem('typesession') // clientes | entidadFinanciera | admin

  // 0️ Bloquear rutas de roles si NO hay typesession
  if (!typesession) {
    // Si la ruta tiene meta.requiresAuth o meta.allowedSessions → NO tiene permiso
    if (to.matched.some(record => record.meta.requiresAuth) ||
        to.meta.allowedSessions) {
      return next('/')  // Solo puede ir al login
    }
  }

  // 1️ Si la ruta requiere login pero NO hay token → redirigir al login
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) return next('/')
    if ( terminos_aceptados === 'incompleto' && to.path !== '/terminosycondiciones' ) {
        return next('/terminosycondiciones');
    } // end if
  } // end if

  // 2️ Validación de roles por ruta
  if (to.meta.allowedSessions) {
    if (!to.meta.allowedSessions.includes(typesession)) {

      // Cliente intenta entrar a rutas que no son suyas
      if (typesession === 'clientes') {
        return next('/servocolecciones')
      }

      // Admin intenta entrar a rutas que no son admin
      if (typesession === 'admin') {
        return next('/administracionusuarios')
      }

      return next('/') // fallback
    }
  }

 next()
})



export default router
